// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pe-settings-tab__import-tabs {
    display: flex;
    flex-direction: column;
    align-items: baseline;
}

.pe-settings-tab__import-tabs .components-tab-panel__tabs {
    width: 100%;
}

.pe-settings-tab__import-tabs .components-tab-panel__tab-content {
    padding-left: 10px;
}

.pe-settings-tab__import-preview-tab {
    width: 100%;
    padding: 10px;
}

.pe-settings-tab__import-preview-tab-content {
    flex: 1;

}

.pe-settings-tab__import-preview-tab-json {
    flex: 1;

}

.pe-settings-tab__import-file-upload-actions {
    width: 100%;
    justify-content: flex-start !important;
    margin-top: 20px;
}

.pe-settings-tab__import-file-upload-info-label {
    font-weight: bold;
}

.components-tab-panel__tab-content {
    width: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}

.pe-settings-tab__import-file-upload-preview {
    background-color: #fff;
    padding: 10px;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/backup-panel/components/tabs-content/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,OAAO;;AAEX;;AAEA;IACI,OAAO;;AAEX;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,WAAW;AACf","sourcesContent":[".pe-settings-tab__import-tabs {\n    display: flex;\n    flex-direction: column;\n    align-items: baseline;\n}\n\n.pe-settings-tab__import-tabs .components-tab-panel__tabs {\n    width: 100%;\n}\n\n.pe-settings-tab__import-tabs .components-tab-panel__tab-content {\n    padding-left: 10px;\n}\n\n.pe-settings-tab__import-preview-tab {\n    width: 100%;\n    padding: 10px;\n}\n\n.pe-settings-tab__import-preview-tab-content {\n    flex: 1;\n\n}\n\n.pe-settings-tab__import-preview-tab-json {\n    flex: 1;\n\n}\n\n.pe-settings-tab__import-file-upload-actions {\n    width: 100%;\n    justify-content: flex-start !important;\n    margin-top: 20px;\n}\n\n.pe-settings-tab__import-file-upload-info-label {\n    font-weight: bold;\n}\n\n.components-tab-panel__tab-content {\n    width: 100%;\n    padding-right: 20px;\n    box-sizing: border-box;\n}\n\n.pe-settings-tab__import-file-upload-preview {\n    background-color: #fff;\n    padding: 10px;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
